import type { FC, ReactNode } from 'react'

import dynamic from 'next/dynamic'
import { Layout } from '@/components/generals/layout'
import { Seo } from '@/components/generals/seo'

// The Modulo screens read window, Firebase auth and the Webflow designer globals while they render,
// exactly like the original single page app, so they render in the browser only. The server page
// carries the metadata until they load, then PageTitle takes over.
const HomePage = dynamic(() => import('@/ui/views').then((views) => views.HomePage), {
    ssr: false,
    loading: () => <Seo title='Your Go-to place for Webflow Components' ogImage='/thumbnail.png' />
})

const Home: FC = (): ReactNode => {
    return (
        <Layout>
            <HomePage />
        </Layout>
    )
}

export default Home
